import { Controller, useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { defaultEditorLength, Editor } from "@/components/ui/editor"
import { TreatmentForm } from "@/modules/admin/treatment/schema/treatment-form-schema"
import { Language, LanguageValues } from "@/types/__generated__/union-types"

type RecommendedFieldName = "germanRecommended" | "frenchRecommended" | "italianRecommended" | "englishRecommended"

const RECOMMENDED_FIELD_BY_LANGUAGE: Record<Language, RecommendedFieldName> = {
  GERMAN: "germanRecommended",
  FRENCH: "frenchRecommended",
  ITALIAN: "italianRecommended",
  ENGLISH: "englishRecommended",
}

const recommendedFields = LanguageValues.map((language) => ({
  language,
  fieldName: RECOMMENDED_FIELD_BY_LANGUAGE[language],
}))

const TreatmentPlanTemplatesSectionRecommendedForm = () => {
  const { t } = useTranslation()

  const form = useFormContext<TreatmentForm>()

  const { control } = form

  return (
    <div className="w-full">
      <div className="text-on-surface-subdued col-span-4 text-sm font-medium">
        <label>{t("admin.treatment.form.recommended")}</label>
      </div>
      <div className="mt-2 grid grid-cols-2 gap-4">
        {recommendedFields.map(({ language, fieldName }, index) => (
          <div key={language} className={index < recommendedFields.length - 2 ? "col-span-1 mb-4" : "col-span-1"}>
            <span className="text-on-surface-subdued text-xs">
              {t(`admin.treatment.form.${language.toLowerCase()}`)}
            </span>
            <Controller
              control={control}
              name={fieldName}
              render={({ field: { name, value, onChange } }) => (
                <Editor
                  minHeight="100px"
                  autofocus={false}
                  value={value}
                  name={name}
                  maxLength={defaultEditorLength}
                  onChange={onChange}
                />
              )}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export { TreatmentPlanTemplatesSectionRecommendedForm }
